// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"743":"ac7adebc","910":"b39135f0"}[chunkId] + ".chunk.css";
};